export default __webpack_public_path__ + "static/media/journals_dark.1119ddc8.png";